import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import result_title from '../../../asset/img/resultquery_title_img.svg';

import Typography from '../../../components/common/Typography';

import Badge from '../../../components/common/Badge';
import { formatNumber } from '../../../common/Util';

const ResultMessageBox = () => {
  const { t } = useTranslation('resultQuery');
  const { t: tCommon } = useTranslation('common');
  const { resultData } = useSelector(state => state.resultQuery);

  return (
    <div className="resultMessageBox">
      <div className="displayFlexColumn">
        <Typography className="resultMessageBox__title" variant="body2Bold">
          {t('resultMessage1')}
        </Typography>
        <div className="displayFlex" style={{ gap: '8px' }}>
          <Badge color="custom">{resultData?.htmPerResultTxt || ''}</Badge>
          {/* <Badge color="custom">{tCommon('expectedResult1')}</Badge> */}
          <Typography variant="body2Medium">{resultData?.htmPerResultMony || ''}</Typography>
        </div>
      </div>
      <img
        src={result_title}
        alt={`${t('resultMessage1')} ${resultData?.htmPerResultTxt} ${
          resultData?.htmPerResultMony
        }`}
      />
    </div>
  );
};

export default ResultMessageBox;
